import { Typography } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

type ParentCardProps = {
  value: string | number
}

export default function ParentCard({ value }: ParentCardProps) {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'

  return (
    <Typography
      sx={{
        fontWeight: 400,
        fontSize: '14px',
        px: 2,
        py: 0.5,
        backgroundColor: isDarkMode ? '#003089' : '#E3F5FF',
        color: isDarkMode ? '#FFFFFF' : '#003F61',
        borderRadius: '200px',
        fontFamily: 'Rubik, sans-serif',
        display: 'inline-block',
        textAlign: 'center',
        lineHeight: 1.4,
      }}
    >
      {value}
    </Typography>
  )
}
